var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-block-video-record"},[_c('div',[(_vm.value.data.audio)?_c('div',[_c('block-audio-viewer',{attrs:{"value":_vm.value}})],1):_c('div',[_c('div',[_c('audio-recorder',{attrs:{"width":_vm.value.size.width,"height":_vm.value.size.height},on:{"finishRecord":_vm.saveAudio}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }